import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from '../hooks/auth';
import api from '../services/api';

const AuthPermissionsContext = createContext({});

export const AuthPermissionsProvider = ({ children }) => {
    const { user } = useAuth();
    const [employees, setEmployees] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!user) {
            setEmployees([]);
            setLoading(false);
            return;
        }

        setLoading(true);
        api.get('/comercial/colaboradores')
            .then(res => {
                const list = res.data?.data || res.data || [];
                setEmployees(list);
            })
            .catch(err => {
                console.error("Erro ao carregar colaboradores do banco:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [user]);

    const getLoggedUserRole = () => {
        if (!user) return null;
        const lowerEmail = (user.email || '').toLowerCase();

        // Papel 100% definido pelo banco (USUARIOS_MONITOR_NOGLE):
        //   active >= 1                                → ativo (isWhitelisted)
        //   is_admin = 1 (ou is_comercial = 2 legado)  → admin
        //   is_comercial >= 1                          → comercial
        if (employees.length > 0) {
            const found = employees.find(e => e.email && e.email.toLowerCase() === lowerEmail);
            if (found) {
                if (found.isWhitelisted === 0 || found.isWhitelisted === false) return null; // inativo
                if (found.isAdmin) return 'admin';
                if (found.isComercial) return 'comercial';
                return null; // sem acesso comercial
            }
        }

        // Enquanto a lista ainda não carregou, assume papel mínimo (não-admin) pra evitar piscar telas de admin.
        return 'comercial';
    };

    const role = getLoggedUserRole();

    const temPermissao = (requiredRoles) => {
        if (!role) return false;
        if (role === 'admin') return true;
        if (Array.isArray(requiredRoles)) {
            return requiredRoles.includes(role);
        }
        return role === requiredRoles;
    };

    const refetchEmployees = () => {
        if (!user) return;
        setLoading(true);
        api.get('/comercial/colaboradores')
            .then(res => {
                const list = res.data?.data || res.data || [];
                setEmployees(list);
            })
            .catch(err => {
                console.error("Erro ao carregar colaboradores do banco:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <AuthPermissionsContext.Provider value={{ role, temPermissao, employees, loading, refetchEmployees }}>
            {children}
        </AuthPermissionsContext.Provider>
    );
};

export const usePermissions = () => {
    const context = useContext(AuthPermissionsContext);
    if (!context) {
        throw new Error('usePermissions deve ser usado dentro de um AuthPermissionsProvider');
    }
    return context;
};
